<template>

  <b-container style="flex: available">
    <b-container>
      <b-container fluid>
        <b-card bg-variant="light">
          <b-form-group
              label-cols="4"
              label-cols-lg="4"
              label-size="md"
              label="Contact Name*:"
              label-for="contactName">
            <b-form-input id="contactName" size="sm"
                          v-model="computedContactName" placeholder="Contact Name" readonly="true"/>
          </b-form-group>

          <b-form-group
              label-cols="4"
              label-cols-lg="4"
              label-size="md"
              label="Contact Phone Number*:"
              label-for="input-sm">
            <b-form-input id="contactTelephoneNumber" size="sm"
                          v-model="computedTelephone" placeholder="Contact Phone Number" readonly="true"/>
          </b-form-group>

          <b-form-group
              label-cols="4"
              label-cols-lg="4"
              label-size="md"
              label="Contact Email Address*:"
              label-for="input-sm">
            <b-form-input id="input-sm" size="sm" v-model="computedEmail"
                          placeholder="Contact Email" readonly="true"/>
          </b-form-group>


          <b-form-group
              label-cols="4"
              label-cols-lg="4"
              label-size="md"
              label="Vineyard Name:"
              label-for="input-sm">
            <b-form-input id="input-sm" size="sm" v-model="vineyardNames"
                          placeholder="Vineyard Names"/>
          </b-form-group>

          <b-form-group
              label-cols="4"
              label-cols-lg="4"
              label-size="md"
              label="Total Property Acres*:"
              label-for="input-sm">
            <b-form-input id="input-sm" size="sm" v-model="totalPropertyAcres"
                          placeholder="Total Property Acres"/>
          </b-form-group>
          <b-form-group
              label-cols="4"
              label-cols-lg="4"
              label-size="md"
              label="Vineyard Acres*:"
              label-for="input-sm">
            <b-form-input id="input-sm" size="sm" v-model="vineyardAcres"
                          placeholder="Vineyard Acres"/>
          </b-form-group>
          <b-form-group
              label-cols="4"
              label-cols-lg="4"
              label-size="md"
              label="Varieties Planted:"
              label-for="input-sm">
            <b-form-input id="input-sm" size="sm" v-model="varietiesPlanted"
                          placeholder="Varieties Planted"/>
          </b-form-group>

          <b-form-group
              label-cols="4"
              label-cols-lg="4"
              label-size="md"
              label="Age Of Vines:"
              label-for="input-sm">
            <b-form-input id="input-sm" size="sm" v-model="ageOfVines"
                          placeholder="Age of Vines"/>
          </b-form-group>


          <b-form-group
              label-cols="4"
              label-cols-lg="4"
              label-size="md"
              label="Are you planning a vineyard replant or new development within the next three years?:"
              label-for="input-sm">
            <b-form-radio-group
                v-model="imminentPlanting"
                :options="yesNoOptions"
                name="waterMeterTracking"
                stacked
            />
          </b-form-group>


          <b-form-group
              label-cols="4"
              label-cols-lg="4"
              label-size="md"
              label="When was this vineyard last receive an Irrigation Distribution Uniformity Assessment?:"
              label-for="input-sm">
            <datepicker v-model="lastIDUAssessment" name="lastIDUDatePicker"
                        style="width: 50%" placeholder="Last Irrigation Distribution Uniformity Assessment Date"/>
          </b-form-group>

          <b-form-group
              label-cols="4"
              label-cols-lg="4"
              label-size="md"
              label="When was soil testing last done in this vineyard?:"
              label-for="input-sm">
            <datepicker v-model="lastSoilTesting" name="lastSoilDatePicker"
                        style="width: 50%" placeholder="Last Soil Testing"/>
          </b-form-group>

          <b-container fluid>

            <b-form-group label="Indicate current certifications (Check Relevant):">
              <b-form-checkbox-group
                  v-model="certifications"
                  :options="certificationsOptions"
                  name="renewableEnergyInstalled"
                  stacked
              />
            </b-form-group>

            <b-form-group label="Indicate current practices (Check Relevant):">
              <b-form-checkbox-group
                  v-model="practices"
                  :options="practicesOptions"
                  name="renewableEnergyInstalled"
                  stacked
              />
            </b-form-group>

          </b-container>

          <div class="button-holder">
            <b-row align-h="center">
              <b-col cols="2"/>
              <b-col cols="8">*Questions marked with an asterisk must be completed to submit the
                form.
              </b-col>
              <b-col cols="2"/>
            </b-row>
          </div>
        </b-card>
      </b-container>
    </b-container>
  </b-container>


</template>
<script>

import swal from 'sweetalert';
import Datepicker from "vuejs-datepicker";
import Bus from "@/eventBus";

const emailRegex = /^([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/i;

export default {
  name: "CreateOperation",
  components: {
    Datepicker
  },
  data() {
    return {
      firstName: '',
      lastName: '',
      telephoneNumber: '',
      id: '',
      email: '',
      errors: [],
      requiredText: "*Required",
      name: '',
      address: '',
      contactName: '',
      contactTitle: '',
      contactTelephoneNumber: '',
      contactEmail: '',
      ownerName: '',
      ownerEmail: '',
      ownerTelephoneNumber: '',
      vineyardNames: '',

      totalPropertyAcres: '',
      vineyardAcres: '',
      varietiesPlanted: '',
      ageOfVines: '',
      imminentPlanting: '',
      vineyardApns: '',
      lastIDUAssessment: '',
      lastSoilTesting: '',

      practices: [],
      practicesOptions: ["Have Carbon Farm Plan",
        "Compost",
        "Mulch",
        "Biochar",
        "Conservation tillage",
        "No-tillage",
        "Dry farming", "Livestock grazing",
        "Hedgerows", "Riparian/River/Ditch Restoration"],
      certifications: [],
      certificationsOptions: ["CCSW", "Organic", "Demeter Biodynamic"],
      yesNoOptions: ["Yes", "No"],
      isSubmitted: true,
      contactPersonMap: [],
      primaryContactId: ''
    }
  },
  computed: {
    validateBusinessName: function () {
      let isValid = this.name !== "Business Name" && this.name !== '';
      console.log("Business Name valid: " + isValid);
      return isValid;
    },
    validateBusinessAddress: function () {
      let isValid = this.address !== "Business Address" && this.address !== '';
      console.log("Business Name valid: " + isValid);
      return isValid;
    },
    validateContactName: function () {
      let isValid = this.contactName !== "Contact Name" && this.contactName !== '';
      console.log("Business Name valid: " + isValid);
      return isValid;
    },
    validateContactTelephoneNumber: function () {
      let isValid = this.contactTelephoneNumber !== "Telephone" && this.contactTelephoneNumber !== '';
      console.log("Business Name valid: " + isValid);
      return isValid;
    },
    validateContactEmail: function () {
      let isValid = this.validateEmailAddress(this.contactEmail);
      console.log("Email Address valid: " + isValid);
      return isValid;
    },
    canSubmit: function () {
      let self = this;
      /*      return this.validateContactEmail && this.validateContactTelephoneNumber
                && this.validateContactName && this.validateBusinessAddress && this.validateBusinessName;*/
      return self.validateEmailAddress(self.contactEmail)
          && self.isFieldValid(self.contactName, "Contact Name")
          && self.isFieldValid(self.contactTitle, "Contact Title")
          && self.isFieldValid(self.contactTelephoneNumber, "Contact Phone Number")
          && self.isFieldValid(self.contactEmail, "Contact Email")
          && self.isFieldValid(self.name, "Company Name")
          && self.isFieldValid(self.address, "Company Address")
          && self.isFieldValid(self.ownerName, "Owner Name")
          && self.isFieldValid(self.ownerEmail, "Owner Email Address")
          && self.isFieldValid(self.totalPropertyAcres, "Total Property Acres")
          && self.isFieldValid(self.vineyardAcres, "Vineyard Acres");
    },
    computedEmail: function () {
      return this.email;
    },
    computedTelephone: function () {
      return this.telephoneNumber
    },
    computedContactName: function () {
      return this.capitalize(this.firstName) + ' ' + this.capitalize(this.lastName);
    }
  },
  mounted() {
    this.$http.get("account/user/" + localStorage.getItem("user"))
        .then(response => {
          let user = response.data;
          this.firstName = user.firstName;
          this.lastName = user.lastName;
          this.telephoneNumber = user.telephoneNumber;
          this.id = user.id;
          this.email = user.email;
        });
  },
  methods: {
    submitOperation: function () {
      let self = this;
      let data = {
        contactName: this.computedContactName,
        contactTitle: this.contactTitle,
        contactTelephoneNumber: this.computedTelephone,
        contactEmail: this.computedEmail,
        vineyardNames: this.vineyardNames,
        name: this.vineyardNames,

        totalPropertyAcres: this.totalPropertyAcres,
        vineyardAcres: this.vineyardAcres,
        varietiesPlanted: this.varietiesPlanted,
        ageOfVines: this.ageOfVines,
        imminentPlanting: this.imminentPlanting,
        vineyardApns: this.vineyardApns,
        lastIDUAssessment: this.lastIDUAssessment,
        lastSoilTesting: this.lastSoilTesting,
        entityType: "VINEYARD",
        practices: this.practices,
        certifications: this.certifications,
        status: 'PENDING'
      };
      console.log("V Request");
      console.log(data);
      self.$http.post('account/add-operation', data, {
        headers: {
          'content-type': 'application/json'
        }
      })
          .then(function (response) {
            console.log(response.data);
            swal("THANK YOU", "Your request has been submitted.", "success");
            Bus.$emit("operation-creation", "reload-groups");
          })
          .catch(function (error) {
            console.log("Something went really wrong: ", error);
          });
    },
    capitalize: function (str) {
      if (str.length === 0) return str;
      return str[0].toUpperCase() + str.substr(1);
    },
    cancel: function () {
      alert('cancel');
    },
    validateEmail: function (mail) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
        return true
      }
      return false
    },

    makeToast: function (message) {
      this.$toasted.info(message, {
        containerClass: 'super-toasty',
        iconPack: 'fontawesome',
        closeOnSwipe: true,
        action: {
          text: 'DISMISS',
          onClick: (e, toastObject) => {
            toastObject.goAway(0);
          }
        },
        icon: {
          name: 'fa-exclamation-triangle',
          after: false
        }
      })
    },
    validateEmailAddress: function (email) {
      let isValid = emailRegex.test(String(email).toLowerCase());
      /*      if (!isValid){
              this.makeToast("You have entered an invalid email address!")
            }*/
      return isValid;
    },
    isFieldValid: function (fieldValue, defaultValue) {
      console.log(Object.keys(fieldValue));
      return fieldValue !== defaultValue && fieldValue !== "";
    }, validateForm: function (self, data) {
      return self.validateEmailAddress(data.contactEmail)
          && self.isFieldValid(data.contactName, "Contact Name")
          && self.isFieldValid(data.contactTitle, "Contact Title")
          && self.isFieldValid(data.contactTelephoneNumber, "Contact Phone Number")
          && self.isFieldValid(data.contactEmail, "Contact Email")
          && self.isFieldValid(data.name, "Company Name")
          && self.isFieldValid(data.address, "Company Address")
          && self.isFieldValid(data.ownerName, "Owner Name")
          && self.isFieldValid(data.ownerEmail, "Owner Email Address")
          && self.isFieldValid(data.totalPropertyAcres, "Total Property Acres")
          && self.isFieldValid(data.vineyardAcres, "Vineyard Acres");
    },
    buildValidationMessage: function () {
      return "Please enter a valid email address.";
    },
    submit: function () {
      event.target.disabled = true;
      let self = this;
      let data = {
        name: this.name,
        address: this.address,
        contactName: this.contactName,
        contactTitle: this.contactTitle,
        contactTelephoneNumber: this.contactTelephoneNumber,
        contactEmail: this.contactEmail,
        ownerName: this.ownerName,
        ownerEmail: this.ownerEmail,
        ownerTelephoneNumber: this.ownerTelephoneNumber,
        vineyardNames: this.vineyardNames,

        totalPropertyAcres: this.totalPropertyAcres,
        vineyardAcres: this.vineyardAcres,
        varietiesPlanted: this.varietiesPlanted,
        ageOfVines: this.ageOfVines,
        imminentPlanting: this.imminentPlanting,
        vineyardApns: this.vineyardApns,
        lastIDUAssessment: this.lastIDUAssessment,
        lastSoilTesting: this.lastSoilTesting,
        entityType: "VINEYARD",
        practices: this.practices,
        certifications: this.certifications,
        status: 'PENDING'
      };
      console.log("V Request");
      console.log(data);
      swal("THANK YOU", "Your request has been submitted.", "success");
      self.$http.post('account/vineyard-request', data, {
        headers: {
          'content-type': 'application/json'
        }
      }).then(function (response) {
        console.log(response.data);
        self.$router.push({path: '/account-requested?type=vineyard'});
      })
          .catch(function (error) {
            console.log("Something went really wrong: ", error);
          });
    }
  }
}
</script>
<style>
.invalid-field {
  color: red;
  size: 14px;
  font-style: italic;
}
</style>
